import { render } from "./PrescriptionContentEditor.vue?vue&type=template&id=55bbacea"
import script from "./PrescriptionContentEditor.vue?vue&type=script&lang=js"
export * from "./PrescriptionContentEditor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__